<template>
  <div class="status-dropdown-select">
    <vs-dropdown class="status-chip-wrapper" vs-trigger-click color="#2D9CDB">
      <div class="status-chip " :style="{ background: colorHex }">
        <span class="aisea-text-12-700-white">{{ value.label }}</span>
        <feather-icon
          class="ml-1"
          icon="ChevronDownIcon"
          svgClasses="h-4 w-4"
        />
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item
          v-for="(option, index) in filteredOptions"
          :key="index"
          @click="onClickStatusOption(option)"
        >
          {{ option.label }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
    },
    value: {
      type: Object,
    },
    onClickOption: {
      type: Function,
      default: () => {},
    },
    clickEvent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    colorHex() {
      return this.value ? `#${this.value.color}` : `#039BE5`;
    },
    filteredOptions() {
      return this.options.filter(element => element.value != this.value.value);
    },
  },
  methods: {
    onClickStatusOption(value) {
      if (this.clickEvent) {
        this.onClickOption(value);
      } else {
        this.$emit("update:value", value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.status-dropdown-select {
  .status-chip-wrapper {
    cursor: pointer;
  }

  .status-chip {
    min-width: 70px;
    height: 24px;
    border-radius: 6px;
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
